var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserOulined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3307 24.5C23.3307 22.8718 23.3307 22.0578 23.1298 21.3953C22.6774 19.9039 21.5102 18.7367 20.0187 18.2843C19.3563 18.0833 18.5422 18.0833 16.9141 18.0833H11.0807C9.45257 18.0833 8.63849 18.0833 7.97606 18.2843C6.48459 18.7367 5.31744 19.9039 4.86501 21.3953C4.66406 22.0578 4.66406 22.8718 4.66406 24.5M19.2474 8.75C19.2474 11.6495 16.8969 14 13.9974 14C11.0979 14 8.7474 11.6495 8.7474 8.75C8.7474 5.85051 11.0979 3.5 13.9974 3.5C16.8969 3.5 19.2474 5.85051 19.2474 8.75Z",
    stroke: "#667085",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOulined);
export default __webpack_public_path__ + "static/media/user-oulined.31431dc1ec74a8f0623114bafcb14474.svg";
export { ForwardRef as ReactComponent };